import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fmtDate } from "../../lib/api";

const Tape = () => (
  <div className="overflow-hidden bg-hot text-ink border-y-2 border-ink -rotate-1 scale-[1.02]" aria-hidden="true">
    <motion.div
      className="flex whitespace-nowrap kicker py-2"
      animate={{ x: ["0%", "-50%"] }}
      transition={{ duration: 18, ease: "linear", repeat: Infinity }}
    >
      {Array.from({ length: 24 }).map((_, i) => (
        <span key={i} className="px-4">RIOT ✶ louder than the algorithm</span>
      ))}
    </motion.div>
  </div>
);

const Empty = () => (
  <div className="col-span-full py-16 sm:py-24 text-center" data-testid="riot-banner-empty">
    <p className="font-serif italic text-2xl sm:text-3xl text-cream">The first RIOT story is dropping soon.</p>
  </div>
);

const Featured = ({ a }) => (
  <>
    <Link to={`/article/${a.slug}`} className="lg:col-span-7 relative overflow-hidden aspect-[4/5] sm:aspect-[16/10] lg:aspect-[4/3] block img-zoom" data-testid="riot-banner-image-link">
      <img src={a.cover} alt={a.title} className="absolute inset-0 h-full w-full object-cover" />
      <span className="absolute top-4 left-4 kicker bg-hot text-ink px-3 py-1.5">Featured</span>
    </Link>
    <div className="lg:col-span-5 flex flex-col justify-between gap-8 lg:pl-4">
      <p className="kicker text-hot">{fmtDate(a.published)} · {a.read_time} min read</p>
      <div>
        <h3 className="display text-[clamp(2.2rem,4vw,4.5rem)] leading-[0.88] text-cream" data-testid="riot-banner-title">{a.title}</h3>
        {a.dek && <p className="font-serif italic text-lg sm:text-xl mt-5 leading-snug text-cream/85">{a.dek}</p>}
      </div>
      <Link to={`/article/${a.slug}`} className="group flex items-center justify-between border-t-2 border-hot pt-4 kicker text-cream hover:text-hot transition-colors" data-testid="riot-banner-read-btn">
        Read the story <ArrowRight className="h-5 w-5 group-hover:translate-x-1.5 transition-transform" />
      </Link>
    </div>
  </>
);

export const RiotBanner = ({ a, linkToSection = true }) => (
  <section className="flip bg-ink overflow-hidden pb-14 sm:pb-20" data-testid="riot-banner">
    <Tape />
    <div className="max-w-[1440px] mx-auto px-5 sm:px-10 pt-10 sm:pt-14">
      {linkToSection && (
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 sm:gap-6 border-b-[3px] border-hot pb-4 mb-8 sm:mb-10">
          <h2 className="wordmark text-hot text-[clamp(5rem,18vw,15rem)] leading-[0.72] pb-[0.12em]" data-testid="riot-banner-heading">riot</h2>
          <Link to="/category/riot" className="kicker text-cream hover:text-hot transition-colors shrink-0 sm:pb-3" data-testid="riot-banner-section-link">
            All RIOT stories →
          </Link>
        </div>
      )}
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">{a ? <Featured a={a} /> : <Empty />}</div>
    </div>
  </section>
);
